/**
 * NetworkBadge — shows current chain + connection status.
 */

import { useState, useEffect, type ReactNode } from 'react';
import { useWallet } from '../modules/wallet/WalletContext.js';
import { getChainConfig } from '@tokenstreaming/shared';

export function NetworkBadge(): ReactNode {
  const { chainId, status } = useWallet();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (status.state !== 'unlocked') return null;

  const chain = getChainConfig(chainId);

  return (
    <div className="network-badge-container">
      <div className={`network-dot ${online ? 'dot-green' : 'dot-red'}`} />
      <span className="network-name">{chain.name}</span>
    </div>
  );
}
